import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OtpInput from 'react-otp-input';
import Button from 'react-bootstrap/Button';
import { useInterval } from '../../../Utilities';
import './OTPInput.scss';
import { Backdrop } from '@material-ui/core';
import { connect } from 'react-redux';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';

const OTPInput = (props) => {
  const [otp, setOtp] = useState('');
  const [count, setCount] = useState(60);
  const [resend, setResend] = useState(false);

  const { contact, currentBranding, resendOtp, verifyOTP, resendText, countryCode, email } = props;
  const [isDisable, setDisable] = useState(false);
  const ContainerStyle = {
    alignItems: 'center',
    justifyContent: 'center',
  };

  const inputStyle = {
    width: '3rem',
    margin: '1rem',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderLeftStyle: 'none',
    borderBottomColor: 'var(--primary-blue)',
  };

  useInterval(() => {
    if (count <= 0) {
      setResend(true);
      return;
    }
    setCount(count - 1);
  }, 1000);

  return (
    <div className='text-center OTPInput'>
      {/* <Backdrop open style={{ zIndex: '0' }} className='d-block d-md-none' /> */}
      {/* <div className='text-center mt-5 mb-0 mb-md-4 mt-md-0 pt-4 pt-md-0 mx-2 justify-content-center'>
        <img src={currentBranding.branding.client_logo} alt='logo' className='loginLogo' />
        <h1 className='loginClientName'>{currentBranding.branding.client_name}</h1>
        <p className='loginClientTagline my-2'>{currentBranding.branding.client_tagline}</p>
      </div> */}
      <p className='OTPInput__heading  mx-4'>
        Enter the 4-digit one time password we have sent you on
      </p>
      {countryCode === '91' ? (
        <p className='OTPInput__mobile mb-0'>
          +{countryCode}-{contact}
        </p>
      ) : null}
      {Boolean(email) && countryCode === '91' ? <p className='OTPInput__mobile mb-0'>and</p> : null}
      <p className='OTPInput__mobile mb-5'>{email || 'your registered email address'}</p>
      <OtpInput
        value={otp}
        onChange={(e) => setOtp(e)}
        numInputs={4}
        separator={<span>-</span>}
        isInputNum
        containerStyle={ContainerStyle}
        inputStyle={inputStyle}
        // focusStyle={}
      />
      {resend ? (
        <p>
          <span
            className='OTPInput__resend mt-5'
            onClick={() => resendOtp()}
            onKeyDown={() => resendOtp()}
            role='button'
            tabIndex='-1'
          >
            {resendText}
          </span>
        </p>
      ) : (
        <p className='OTPInput__timer mt-5'>
          Resend OTP in 0:
          {count < 10 ? '0' : null}
          <span>{count}</span>
        </p>
      )}
      <div className='justify-content-center mx-4 pb-3'>
        <Button
          style={{ width: '50%' }}
          variant='loginPrimary'
          disabled={!(otp.length === 4)}
          onClick={
            otp.length === 4
              ? () => {
                  verifyOTP(otp);
                  setOtp('');
                }
              : null
          }
        >
          Verify
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentBranding: getCurrentBranding(state),
});

export default connect(mapStateToProps, null)(OTPInput);

OTPInput.propTypes = {
  resendOtp: PropTypes.func.isRequired,
  verifyOTP: PropTypes.func.isRequired,
  resendText: PropTypes.string.isRequired,
  contact: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};
